define([
	'amdi18n-loader?!internal_util/nls/Util_strings'
], function (
	Strings
) {
	'use strict';

	function isArray(array) {
		if (Object.prototype.toString.apply(array) === '[object Array]') {
			return true;
		}

		return false;
	}
        
        function uniqueAttributesByName(requestedAttributes) {
            var tempAttrNames = Array();
            var uniqueAttr = requestedAttributes.filter(function(item, pos) {
                    if (tempAttrNames.indexOf(item.name()) >= 0) {
                        return false;
                    } else {
                        tempAttrNames.push(item.name());
                        return true;
                    }
                });
            return uniqueAttr;
        }
        
	function isValidString(string) {
		if (typeof string === 'string' && string !== '') {
			return true;
		}

		return false;
	}

	function isValidURL(url, relativeAllowed) {
		if (typeof relativeAllowed !== 'boolean') {
			relativeAllowed = false;
		}

		if (isValidString(url) && (/^((http|ws)s?:)?\/\/\S*$/.test(url) ||
				(relativeAllowed && /^[^\s\/]\S*$/.test(url)))) {
			return true;
		}

		return false;
	}

	function isValidDate(date) {
		try {
			new Date(date);
			return true;
		} catch (error) {
			return false;
		}
	}

	function endsWith(string, suffix) {
		return (string.indexOf(suffix) === (string.length - suffix.length));
	}

	function serialize(object) {
		var serializedObject,
			i;

		if (object === null) {
			return null;
		} else if (isArray(object)) {
			serializedObject = new Array();

			for (i = 0; i < object.length; i++) {
				if (object[i].hasOwnProperty('toObject')) {
					serializedObject.push(object[i].toObject());
				} else {
					serializedObject.push(object[i]);
				}
			}
		} else if (object.hasOwnProperty('toObject')) {
			serializedObject = object.toObject();
		} else {
			serializedObject = object;
		}

		return serializedObject;
	}

	function toString(object, depth) {
		var i,
			key,
			size,
			string = '';

		if (!isNaN(depth)
			&& depth > 10) {
			return 'max depth reached';
		} else if (isNaN(depth)) {
			depth = 0;
		}

		if (object === null) {
			return 'NULL';
		} else if (isValidString(object)) {
			return object;
		} else if (isArray(object)) {
			string += '[ ';

			for (i = 0; i < object.length; i++) {
				if (i !== 0) {
					string += ', ';
				}

				string += toString(object[i], depth + 1);
			}

			return (string += ' ]');
		} else if (object instanceof Error && object.hasOwnProperty('message')) {
			return object.message;
		} else if (typeof object === 'object') {
			if (typeof object['toObject'] === 'function') {
				return toString(object.toObject(), depth + 1);
			}

			if (object.hasOwnProperty('readyState')
					&& object.hasOwnProperty('status')
					&& object.hasOwnProperty('statusText')) {
				switch (object['status']) {
				case 0:
					return Strings.connection_timeout;
				default:
					return object['statusText'];
				}
			}

			size = objectSize(object);
			string += '{ ';

			for (key in object) {
				if (object.hasOwnProperty(key)) {
					string += key + ': ' + toString(object[key], depth + 1);

					if (--size > 0) {
						string += ', ';
					}
				}
			}

			return (string += ' }');
		}

		return object;
	}

	function toDateString(date) {
		var dateOptions = {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
				hour12: false
			};

		if (!date instanceof Date) {
			try {
				date = new Date(date);
			} catch (error) {
				return date;
			}
		}

		return date.toLocaleString(undefined, dateOptions);
	}

	function toHtml(string) {
		var entityMap = {
				"&": "&amp;",
				"<": "&lt;",
				">": "&gt;",
				'"': '&quot;',
				"'": '&#39;',
				"/": '&#x2F;',
				"\n" : '<br>'
			};

		return string.replace(/[&<>"'\/]|[\n]/g, function (string) {
			return entityMap[string];
		});
	}

	function objectHasValue(object, value) {
		for (var prop in object) {
			if(object.hasOwnProperty(prop)) {
				if(object[prop] === value) {
					return true;
				}
			}
		}

		return false;
	}

	function objectSize(object) {
		var size = 0,
			key = null;

		for (key in object) {
			if (object.hasOwnProperty(key)) {
				size++;
			}
		}

		return size;
	}

	function copy(object) {
		return JSON.parse(JSON.stringify(object));
	}

	function base64Decode(string) {
		return decodeURIComponent(escape(window.atob(string)));
	}

	function base64Encode(string) {
		return window.btoa(unescape(encodeURIComponent(string)));
	}

	function arrayBufferToString(arrayBuffer) {
		var chunkSize = 0x8000,
			charArray = [],
			i;

		arrayBuffer = new Uint8Array(arrayBuffer);

		if (window.TextDecoder) {
			return new window.TextDecoder('utf-8').decode(arrayBuffer);
		}

		for (i = 0; i < arrayBuffer.length; i += chunkSize) {
			charArray.push(String.fromCharCode.apply(null, arrayBuffer.subarray(i, i + chunkSize)));
		}

		return charArray.join('');
	}

	function stringToArrayBuffer(string) {
		if (window.TextEncoder) {
			return new window.TextEncoder('utf-8').encode(string);
		}

		return new Uint8Array(string.split('').map(function (c) {
				return c.charCodeAt(0);
			}));
	}

	function currentURL(pathOnly, hostOnly) {
		var currentURL = window.location.host + window.location.pathname;

		if (pathOnly && currentURL[currentURL.length - 1] !== '/') {
			currentURL = currentURL.substring(0, currentURL.lastIndexOf('/') + 1);
		}

		if (!hostOnly) {
			currentURL = window.location.protocol + '//' + currentURL;
		}

		return currentURL;
	}

	function isSameHost(firstURL, secondURL) {
		if (typeof secondURL === 'undefined') {
			secondURL = currentURL(true);
		}

		if (!isValidURL(firstURL) || !isValidURL(secondURL)) {
			return false;
		}

		if (firstURL.indexOf(':') !== firstURL.lastIndexOf(':')
				&& secondURL.indexOf(':') !== secondURL.lastIndexOf(':')) {
			firstURL = firstURL.substring(firstURL.indexOf(':') + 3, firstURL.lastIndexOf(':'));
			secondURL = secondURL.substring(secondURL.indexOf(':') + 3, secondURL.lastIndexOf(':'));
		} else {
			firstURL = firstURL.substring(firstURL.indexOf(':') + 3, firstURL.lastIndexOf('/'));
			secondURL = secondURL.substring(secondURL.indexOf(':') + 3, secondURL.lastIndexOf('/'));
		}

		return (firstURL === secondURL);
	}

	function parseParameters(url, queryParameters) {
		var parameterString = url,
			separator = queryParameters ? '?' : '#',
			parameters = new Object(),
			parameter,
			i;
	
		if (typeof url === 'undefined') {
			parameterString = window.location.href;
		}

		parameterString = parameterString.slice(parameterString.indexOf(separator) + 1).split('&');

		for (i = 0; i < parameterString.length; i++) {
			if (parameterString[i].indexOf('=') === -1) {
				continue;
			}

			parameter = parameterString[i].split('=');

			parameters[decodeURIComponent(parameter[0])] = decodeURIComponent(parameter[1]);
		}

		return parameters;
	}
	
	function makeParameterString(parameters, encode) {
		var key,
				first = true,
				result = '';
		
		if (encode !== false) {
			encode = true;
		}
		
		for (key in parameters) {
			if (! parameters.hasOwnProperty(key)) {
				continue;
			}
			if (! first) {
				result += '&';
			} else {
				first = false;
			}
			result += key + '=' + (encode ? encodeURIComponent(parameters[key]) : parameters[key]);
		}
		
		return result;
	} 

	function callCallbacks(callbacks, data, doneCallback) {
		var responses = new Array(),
			remainingCallbacks,
			i;

		if (typeof doneCallback === 'undefined' && typeof data === 'function') {
			doneCallback = data;
		}

		if (isArray(callbacks) && callbacks.length !== 0) {
			remainingCallbacks = callbacks.length;

			var internalDone = function(response) {
				if (typeof response !== 'undefined') {
					responses.push(response);
				}

				if (--remainingCallbacks === 0) {
					doneCallback(responses);
				}
			};

			for (i = 0; i < callbacks.length; i += 1) {
				if (typeof data === 'function') {
					callbacks[i](internalDone);
				} else if (typeof data !== 'function' && typeof doneCallback === 'function') {
					callbacks[i](data, internalDone);
				} else if (typeof data !== 'function' && typeof doneCallback !== 'function') {
					callbacks[i](data);
				} else {
					// ignore invalid callback
				}
			}
		} else if (typeof callbacks === 'function') {
			if (typeof doneCallback === 'undefined') {
				callbacks(data);
			} else {
				callbacks(data, doneCallback);
			}
		} else if (typeof doneCallback === 'function') {
			doneCallback(responses);
		}
	}

	function randomString(length) {
		var charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
			result = '',
			i;

		if (typeof length !== 'number' || length < 0) {
			length = 32;
		}

		if (window.crypto && window.crypto.getRandomValues) {
			var values = new Uint32Array(length);
			window.crypto.getRandomValues(values);

			for (i = 0; i < length; i++) {
				result += charset[values[i] % charset.length];
			}

			return result;
		}

		for (i = 0; i < length; i++) {
			result += charset[Math.floor(Math.random() * charset.length)];
		}

		return result;
	}

	function generateId(value) {
		var hash = 0,
			i;

		if (typeof value === 'undefined') {
			value = randomString();
		} else if (value.length === 0) {
			return hash;
		}

		if (value.match(/^[a-zA-Z0-9_-]+$/)) {
			return value;
		}

		for (i = 0; i < value.length; i++) {
			hash = ((hash << 5) - hash) + value.charCodeAt(i);
			hash = hash & hash; // Convert to 32bit integer
		}

		if (hash < 0) {
			hash *= -1;
		}

		return '' + hash;
	}

	/**
	 * Find the index of the array element that satisfies the provided testing function.
	 * If such an element is not found, -1 is returned.
	 * 
	 * @param {Array} array Array to search for.
	 * @param {function} callback Function to execute on each value in the array, taking three arguments:
	 * element - The current element being processed in the array.
	 * index - The index of the current element being processed in the array.
	 * array - The array find was called upon.
	 * @returns {Number} Found index or -1.
	 */
	function findIndex(array, callback) {
		var i;
		for (i = 0; i < array.length; i++) {
			if (callback(array[i], i, array)) {
				return i;
			}
		}
		return -1;
	}

	/**
	 * Find an array element that satisfies the provided testing function.
	 * If such an element is not found, null is returned.
	 * 
	 * @param {Array} array Array to search for.
	 * @param {function} callback Function to execute on each value in the array, taking three arguments:
	 * element - The current element being processed in the array.
	 * index - The index of the current element being processed in the array.
	 * array - The array find was called upon.
	 * @returns {Object|null} Found element or null.
	 */
	function find(array, callback) {
		var i = findIndex(array, callback);
		return (i === -1) ? null : array[i];
	}

	return {
		isArray : isArray,
		uniqueAttributesByName : uniqueAttributesByName,
		isValidString : isValidString,
		isValidURL : isValidURL,
		isValidDate : isValidDate,
		endsWith : endsWith,
		serialize : serialize,
		toString : toString,
		toDateString : toDateString,
		toHtml : toHtml,
		objectHasValue : objectHasValue,
		objectSize : objectSize,
		copy : copy,
		base64Decode : base64Decode,
		base64Encode : base64Encode,
		arrayBufferToString : arrayBufferToString,
		stringToArrayBuffer : stringToArrayBuffer,
		currentURL : currentURL,
		isSameHost : isSameHost,
		parseParameters : parseParameters,
		makeParameterString : makeParameterString,
		callCallbacks : callCallbacks,
		randomString : randomString,
		generateId : generateId,
		findIndex : findIndex,
		find : find
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/util/Util.js
// module id = 0
// module chunks = 6